<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        title
      }}</span>
      <div class="close-button cursor-pointer" @click="$emit('close')">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <div class="spacing-px-20 py-20">
        <div class="columns is-multiline">
          <div
            v-for="(detail, index) in details"
            :key="index"
            class="column is-narrow email-wrapper"
          >
            {{ `${detail}${details.length - 1 === index ? `.` : `,`}` }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalUserDetails",
  props: {
    title: {
      type: String,
      default: ""
    },
    details: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  background-color: $white;
}

.modal-content-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100px;
}

.email-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
